import React from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';
import { componentService } from 'js/services/component.service';

import style from './Balance.scss';

export const Balance = ({ type }) => {
    const balance = useUserSelector(prop('balance'));
    const { balances = {} } = balance || {};
    const formatter = useFormatter();

    if (!balances[type]) {
        return null;
    }

    const { amount = 0, currencyCode } = balances[type];

    return (
        <span className={style.balance}>
            {currencyCode === 'XXX' ? amount : formatter.formatCurrency(amount, { currencyCode })}
        </span>
    );
};

componentService.registerWebContentComponents({
    BonusBalance: () => <Balance type="bonus_balance" />,
    TotalBonusBalance: () => <Balance type="total_bonus_balance" />,
    RealGamingBalance: () => <Balance type="real_gaming_balance" />,
    TotalFreeSpinsBalance: () => <Balance type="free_spin_balance" />,
    WithdrawableBalance: () => <Balance type="withdrawable_balance" />,
    CasinoGamingBalance: () => <Balance type="casino_gaming_balance" />,
    BonusPendingWinnings: () => <Balance type="bonus_pending_winnings" />,
    RingfencedRealBalance: () => <Balance type="ringfenced_real_balance" />,
    BrokenGamesRealBalance: () => <Balance type="broken_games_real_balance" />,
    CasinoTableRealBalance: () => <Balance type="casino_table_real_balance" />,
    BrokenGamesBonusBalance: () => <Balance type="broken_games_bonus_balance" />,
    Balance
});
